<!-- cbta-datepicker.component.html -->

@if (inputDesign === "searchType") {
	<div class="cbta-datepicker">
		<input
			#datePicker
			[owlDateTime]="cbtaPicker"
			[owlDateTimeTrigger]="cbtaPicker"
			[placeholder]="placeHolder"
			[min]="normalizedMin"
			readonly
			[formControl]="datePickerInput"
		/>
		<img class="calendar-icon" [owlDateTimeTrigger]="cbtaPicker" src="assets/icon_calendar.svg" alt="calendar" />
		<owl-date-time
			#cbtaPicker
			pickerType="calendar"
			[startAt]="startAt"
			(dateSelected)="handleClose($event)"
			(afterPickerClosed)="handleClose(datePickerInput.value)"
		></owl-date-time>
	</div>
}

@if (inputDesign === "formType") {
	<div class="form-element" [class.cbta-datepicker--read-only]="readOnly">
		<mat-label for="syllabus-start-date">{{ label }}</mat-label>
		@if (readOnly) {
			<mat-form-field appearance="outline" class="form-field-responsive mt-1 w-full">
				<input #datePicker matInput [placeholder]="placeHolder" type="text" readonly [formControl]="datePickerInput" />
				<span class="aa-mat-icon mr-4 text-grey-60" matSuffix>event</span>
			</mat-form-field>
		} @else {
			<mat-form-field appearance="outline" class="form-field-responsive mt-1 w-full">
				<input
					#datePicker
					matInput
					[placeholder]="placeHolder"
					type="text"
					[owlDateTimeTrigger]="startDate"
					[owlDateTime]="startDate"
					[min]="normalizedMin"
					[readonly]="true"
					[formControl]="datePickerInput"
				/>
				<owl-date-time
					#startDate
					pickerType="calendar"
					[startAt]="startAt"
					(dateSelected)="handleClose($event)"
					(afterPickerClosed)="handleClose(datePickerInput.value)"
				></owl-date-time>
				<span class="aa-mat-icon mr-4 text-grey-60" [owlDateTimeTrigger]="startDate" matSuffix>event</span>
			</mat-form-field>
		}
	</div>
}
